import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import $ from 'jquery';

import Header from './views/ExComponents/Header';
import SiteMap from './views/ExComponents/SiteMap';
import Footer from './views/ExComponents/Footer';

const MainTemplateConfig = ({ component: Component, ...rest }) => {
  useEffect(() => {
    $('.ami').off();
    $('.site_map .smc').off();
    $('.site_map .sm_menu').off();
    $('.site_map .sm_list').off();

    $('.ami').on('click', () => {
      $('.site_map').animate({ left: '0' }, 300);
      $('.bg').show();
    });
    $('.site_map .smc').on('click', () => {
      console.log('hide: smc');
      $('.site_map').animate({ left: '-360px' }, 100);
      $('.bg').hide();
    });
    $('.site_map .sm_menu').on('click', () => {
      console.log('hide: sm_menu');
      $('.site_map').animate({ left: '-360px' }, 100);
      $('.bg').hide();
    });
    $('.site_map .sm_list').on('click', () => {
      console.log('hide: sm_list');
      $('.site_map').animate({ left: '-360px' }, 100);
      $('.bg').hide();
    });
  });

  return (
    <Route
      {...rest}
      render={props => {
        return (
          <div id="wrap" className="main">
            <div className="bg" />

            <Header {...props} />

            <SiteMap {...props} />

            <div>
              <Component {...props} />
            </div>

            <Footer {...props} />
          </div>
        );
      }}
    />
  );
};

MainTemplateConfig.propTypes = {
  component: PropTypes.any.isRequired,
};

const mapStateToProps = state => {
  return {
    authStatus: state.auth.login.login,
    profile: state.auth.login.values,
    user: state.auth.login,
  };
};

const MainTemplate = connect(mapStateToProps, {})(MainTemplateConfig);
export { MainTemplate as default };
